import { Component, OnInit, Input } from '@angular/core';

import { AuthenticationService } from '../../../login/authentication.service'

import { ParticipantformService} from '../participantform.service';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-participantdetails',
  templateUrl: './participantdetails.component.html',
  styleUrls: ['./participantdetails.component.css'],
})
export class ParticipantdetailsComponent implements OnInit {
  items = JSON.parse(localStorage.getItem('currentUser'));

  @Input() parentData;
  ///@Input('data') participantdatainput;

  @Input() participant: UntypedFormGroup;

  //participantdata: any;

  constructor(public ParticipantformService: ParticipantformService, private AuthenticationService: AuthenticationService) {}

  ngOnInit(): void {
    this.AuthenticationService.check_logged_in()

    //this.participantdata = JSON.parse(this.participantdatainput);
  }
}

// https://www.pluralsight.com/guides/passing-data-to-nested-component-@input
// https://stackoverflow.com/questions/40468172/how-to-share-data-between-components-using-a-service-properly
